/**
 * Structural check for an Axios-like HTTP error status — works against any
 * thrown error shape without requiring an `AxiosError` instance (useful when
 * the error passed through a mock or a non-Axios client in tests).
 */
export function isHttpStatus(error: unknown, status: number): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    (error as { response?: { status?: number } }).response?.status === status
  );
}

/** A `404` almost always means "not found" or, for a feature-gated module, "not entitled". */
export function isNotFoundError(error: unknown): boolean {
  return isHttpStatus(error, 404);
}
